import { CounsellorObj } from "components/LSRevamp/CounsellorLandingPage/CounsellorRelatedStats/CounsellorStatsInterface";
export const statsObj: CounsellorObj[] = [
  {
    title: "Comprehensive Knowledge Base",
    description:
      "Leap training modules ensure counsellors are up to date with latest development",
    image: `${process.env.CDN_URL}/assets/images/LSRevamp/knowledge.svg`,
  },
  {
    title: "Profile-based allocation",
    description:
      "Counsellors are allocated based on your profile to serve you better",
    image: `${process.env.CDN_URL}/assets/images/LSRevamp/profile.svg`,
  },
  {
    title: "Live Feedback",
    description:
      "Regular feedback sessions to ensure your satisfaction at every stage",
    image: `${process.env.CDN_URL}/assets/images/LSRevamp/feedback.svg`,
  },
];
